import { XCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const PreCheckFormFailed = () => {

    const location = useLocation()

    const message = location.state?.message

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white shadow-xl rounded-2xl p-8 text-center">

                {/* Failed Icon */}
                <div className="flex justify-center mb-6">
                    <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100">
                        <XCircle className="w-8 h-8 text-red-600" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-2xl font-semibold text-gray-900 mb-2">
                    Something Went Wrong
                </h1>

                {/* Description */}
                <p className="text-gray-600 mb-6">
                    {message || "Your pre check could not be completed."}
                </p>

                {/* Info Box */}
                <div className="bg-gray-100 rounded-lg p-4 text-sm text-gray-700 mb-6">
                    Please contact support if you believe this is a mistake.
                    We'll be happy to assist you.
                </div>

                {/* Subtle hint */}
                <p className="text-xs text-gray-400">
                    This window can now be closed.
                </p>
            </div>
        </div>
    );
};

export default PreCheckFormFailed
